import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MOBILEVIEWLABEL } from '../stepper.constant';

@Component({
  selector: 'app-stepperwithroute',
  templateUrl: './stepperwithroute.component.html',
  styleUrls: ['./stepperwithroute.component.scss']
})
export class StepperwithrouteComponent implements OnInit {

  stepperItems: { id: number, label: string,name?:string, route?: string }[] = [
    { id: 0, label: 'Step 1', name: '1', route: 'stepone' },
    { id: 1, label: 'Step 2', name: '2', route: 'steptwo' },
    { id: 2, label: 'Step 3', name: '3', route: 'stepfinal' }
  ];

  stepperTitle: string = 'English'
  totalSteps: number | undefined;
  currentStep: any = 0;
  mobileViewLabel = MOBILEVIEWLABEL.english;

  stepperItemsSpanish: { id: number, label: string, route?: string }[] = [
    { id: 0, label: 'Paso 1', route: 'stepone' },
    { id: 1, label: 'Paso 2', route: 'steptwo' },
    { id: 2, label: 'Paso 3', route: 'stepfinal' }
  ];

  stepperTitleSpanish: string = 'Español'
  totalStepsSpanish: number | undefined;
  currentStepSpanish: any = 0;
  mobileViewLabelSpanish = MOBILEVIEWLABEL.spanish;

  stepperItemsHindi: { id: number, label: string, route?: string }[] = [
    { id: 0, label: 'चरण 1', route: 'stepone' },
    { id: 1, label: 'चरण 2', route: 'steptwo' },
    { id: 2, label: 'चरण 3', route: 'stepfinal' }
  ];

  stepperTitleHindi: string = 'हिन्दी'
  totalStepsHindi: number | undefined;
  currentStepHindi: any = 0;
  mobileViewLabelHindi = MOBILEVIEWLABEL.hindi;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.totalSteps = this.stepperItems.length;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        if (params['id'] === 'stepperId1') {
          if (params['stepId']) {
            this.currentStep = parseInt(params['stepId']);
          } else {
            this.currentStep = 0;
          }
        } else if (params['id'] === 'stepperId11') {
          if (params['stepId']) {
            this.currentStepSpanish = parseInt(params['stepId']);
          } else {
            this.currentStepSpanish = 0;
          }
        } else if (params['id'] === 'stepperId111') {
          if (params['stepId']) {
            this.currentStepHindi = parseInt(params['stepId']);
          } else {
            this.currentStepHindi = 0;
          }
        }
      }
    });
  }

}
